<template>
	<popup
			@updateClosePopup="onCloseDialog"
			@updateSave="onSave"
			height-head="40px"
			:title="getTitle"
			:fullscreen="false"
			:width="otherStatementsItem ? '1400' : '340'"
			:btn-text="otherStatementsItem ? 'Confirm' : 'Generate'"
	>
		<main-table
				v-if="otherStatementsItem"
				padding="0 0 10px"
				:itemsPerPageAmount="999"
				:headers="getHeaders"
				:listItems="otherStatementsItem"
				:is-hide-header="false"
				:is-pagination="false"
				:is-last-row="false"
				:check-all="checkAll"
				:indeterminate="indeterminate"
				@updateCheckOrder="onCheckOrder"
				@updateCheckOrders="onCheckOrders"
		></main-table>
		<div v-else>
			<field
					margin="10px 0 0 0"
					width="300px"
					label="Period"
					placeholder="Select period"
					@updateSelect="onSelect($event, 'month')"
					:autocompleteValue="month"
					:items="managerStatementsMonth"
					:isClearable="false"
					item-text="name"
					item-value="date"
					is-select
			></field>
			<field
					:class-error="$v.department && $v.department.$error"
					margin="10px 0 16px 0"
					width="300px"
					label="Department"
					placeholder="Select department"
					@updateSelect="onSelect($event, 'department')"
					:autocompleteValue="department"
					:items="managerStatementsDepartments"
					:isClearable="false"
					is-select
					is-required
			></field>
<!--			<template v-if="isAdvertising">-->
<!--				<div v-if="manager">{{ manager }}</div>-->
<!--				<field-->
<!--						:class-error="$v.advertising && $v.advertising.$error"-->
<!--						margin="16px 0 20px 0"-->
<!--						width="300px"-->
<!--						label="Advertising"-->
<!--						type="number"-->
<!--						placeholder="Enter sum"-->
<!--						:setInputValue="advertising"-->
<!--						@updateInput="onInput"-->
<!--						icon="dollar"-->
<!--						is-required-->
<!--				></field>-->
<!--			</template>-->
		</div>
	</popup>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import Popup from "@/shared/Popup/Popup";
// validations
// import { minValue, required } from "vuelidate/lib/validators";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
// constants
import tableHeaders from "@/components/Accounting/ManagerStatements/ManagerStatementsForm/tableHeaders";

export default {
	name: "OtherStatementsForm",
	mixins: [ validationMixin ],
	components: { Popup },
	props: {
		otherStatementsItem: Array,
		managerStatementsMonth: Array,
		managerStatementsDepartments: Array
	},
	computed: {
		...mapGetters([
			"managerStatementsItem",
			"safetyStatementsView",
		]),
		getHeaders() {
			return tableHeaders[this.department];
		},
		getTitle() {
			if (this.otherStatementsItem && this.department && this.managerStatementsDepartments) {
				return this.managerStatementsDepartments.find(item => item.id === this.department).value;
			}
			return 'Other';
		}
	},
	validations() {
		// const advertising = this.isAdvertising ? { required, minValue: minValue(0) } : {};
		return {
			department: { required },
			// advertising,
		};
	},
	data: () => ({
		month: null,
		department: null,
		advertising: null,
		manager: null,
		// isAdvertising: false,
		managerStatementsItemList: null,

		checkAll: false,
		selected: [],
		indeterminate: false,
	}),
	methods: {
		...mapActions([
			'getManagerStatementsCreate',
			'actionPreloader',
			'onManagerStatements',
			'setAlert',
			'getStatementsDefaultCreateMonth',
		]),

		onCheckOrder(orderId) {
			const idx = this.selected.findIndex(({ dispatcher_id }) => dispatcher_id === orderId);
			const item = this.otherStatementsItem.find(({ dispatcher_id }) => dispatcher_id === orderId);
			if (idx === -1) {
				this.selected.push(item);
			} else {
				this.selected.splice(idx, 1);
			}

			if (!this.selected.length) {
				this.indeterminate = false;
				this.checkAll = false;
			}
			if (this.selected.length && this.selected.length !== this.otherStatementsItem.length) {
				this.indeterminate = true;
			}

			if (this.selected.length === this.otherStatementsItem.length) {
				this.indeterminate = false;
				this.checkAll = true;
			}
		},
		onCheckOrders(value) {
			if (value) {
				this.selected = this.otherStatementsItem.map((body) => body);
			} else {
				this.selected = [];
				this.indeterminate = false;
			}

			this.checkAll = value;
			this.otherStatementsItem.forEach((item) => (item.isCheck = value));
		},

		async onSave() {
			this.$v.$touch();
			if (this.$v.$error) {
				this.setAlert({ type: "error", message: "Failed to save the manager statement. Please check the data and try again ⚠️" });
				return;
			}

			this.actionPreloader(true);

			try {
				if (this.otherStatementsItem) {
					const data = this.department === 0 ? this.selected : this.otherStatementsItem;
					const { status } = await this.onManagerStatements(data);

					this.setAlert({
						type: status ? "success" : "error",
						message: status
							? "Manager statement saved successfully 🎉"
							: "Failed to save manager statement. Please try again ⚠️"
					});

					if (status) this.onCloseDialog(1);
				} else {
					const { month: { date, name }, department } = this.$data;
					// const { month: { date, name }, department, advertising } = this.$data;
					const values = { month: date, month_name: name, department };

					// if (this.isAdvertising) values.advertising = advertising;

					await this.getManagerStatementsCreate(values);
				}
			} catch (error) {
				this.setAlert({ type: "error", message: "❌Unexpected error occurred" });
				console.error("❌Manager statement error:", error);
			} finally {
				this.actionPreloader(false);
			}
		},
		onCloseDialog(value) {
			this.$emit('updateCloseDialog', value);
		},
		async onSelect({ value }, key) {
			// this[key] = value?.id || value;
			this[key] = value.id;
			// this.isAdvertising = this[key] === 2;
			this.manager = value?.manager;
			if (key === "month") {
				this[key] = value;
				const month = value?.date;
				this.department = null;
				await this.getStatementsDefaultCreateMonth( month );
			}
		},
		onInput({ value }) {
			this.advertising = value;
		}
	},
	beforeMount() {
		if (this.otherStatementsItem) this.department = +this.otherStatementsItem[0].department;
		this.month = this.managerStatementsMonth[0];

		if (this.managerStatementsItem) this.managerStatementsItemList = this.managerStatementsItem;
	},
	watch: {
		otherStatementsItem(value, oldValue) {
			if (value !== oldValue) {
				this.otherStatementsItem = value;
			}
		},
	},
};
</script>

<style scoped lang="scss">

</style>
